import { useEffect, useState } from 'react';
import axiosInstance from '../util/axiosConfig';

const useVendorsForModal = (open) => {
  const [vendors, setVendors] = useState([]);
  const [vendorsLoading, setVendorsLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setVendorsLoading(true);
    axiosInstance
      .get('/vendors')
      .then((res) => setVendors(res.data.vendors || []))
      .catch(() => setVendors([]))
      .finally(() => setVendorsLoading(false));
  }, [open]);

  return { vendors, setVendors, vendorsLoading };
};

export default useVendorsForModal;
